import {
  LuArrowLeftRight,
  LuFolder,
  LuLandmark,
  LuBuilding2,
  LuTag,
  LuCircleDollarSign,
  LuFile,
  LuHash,
  LuText,
  LuCalendar,
  LuUser,
  LuClock,
  LuFilter,
  LuTriangleAlert,
  LuEyeOff,
  LuArrowUpRight,
  LuArrowDownLeft,
} from 'react-icons/lu';

/**
 * Map filter entity+column to a lucide icon (matches sidebar icon style).
 *
 * Lives in its own module because both the filter menu and the value-first
 * suggestion list need it, and importing one from the other would be circular.
 */
export const getFilterIcon = (filter) => {
  const key = `${filter.entity}.${filter.column}`;
  const iconMap = {
    'Movement.type': LuArrowLeftRight,
    'Movement.category_id': LuFolder,
    'Movement.account_id': LuLandmark,
    // The two legs of a transfer read as direction, not as another bank.
    'Movement.from_account_id': LuArrowUpRight,
    'Movement.to_account_id': LuArrowDownLeft,
    'Account.id': LuLandmark,
    // The institution behind the account, not the account itself.
    'Movement.source_id': LuBuilding2,
    'Tag.id': LuTag,
    'Movement.currency': LuCircleDollarSign,
    'CurrencyExchange.currency_target': LuCircleDollarSign,
    'Movement.note': LuText,
    'Movement.amount': LuHash,
    'Movement.created_by': LuUser,
    'SourceFile.id': LuFile,
    'Movement.date': LuCalendar,
    'Movement.created_at': LuClock,
    'Movement.alert': LuTriangleAlert,
    'Movement.is_ignored': LuEyeOff,
  };
  return iconMap[key] || LuFilter;
};

export default getFilterIcon;
